import { STATSIG_EXPERIMENTS, STATSIG_EXPERIMENTS_BUCKETS } from '@src/config/statsig-experiments.config'
import { useStatsigExperiment } from '@src/experiments/statsig-integration/useStatsigExperiment'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { BreadCrumbDS } from './bread-crumb-ds'
import { BreadCrumbLegacy } from './legacy-bread-crumb'

import type { BreadCrumbProps } from './bread-crumb.types'

const BreadCrumb = (props: BreadCrumbProps) => {
  const breadCrumbExp = useStatsigExperiment(STATSIG_EXPERIMENTS.PDP_BREADCRUMB)
  const isDefaultBucket = breadCrumbExp?.experimentBucket === STATSIG_EXPERIMENTS_BUCKETS.CONTROL

  const trimmedProps = {
    ...props,
    directory: {
      ...props.directory,
      // If control bucket keep L2 and product title
      // If not control bucket trim last path, i.e. product title
      paths: isDefaultBucket ? props.directory.paths.slice(-2) : props.directory.paths?.slice(0, -1),
    },
  }

  const breadCrumbProps = props.isPDP ? trimmedProps : props
  const removeLastPathStyle = !isDefaultBucket && props?.isPDP

  if (shouldUseDesignSystem()) {
    return <BreadCrumbDS {...breadCrumbProps} />
  }
  return <BreadCrumbLegacy {...breadCrumbProps} removeLastPathStyle={removeLastPathStyle} />
}

export default BreadCrumb
export type { BreadCrumbProps } from './bread-crumb.types'
